import { createFileRoute } from "@tanstack/react-router";

import { BrowserSettingsPage } from "../components/settings/BrowserSettingsPage";

export const Route = createFileRoute("/settings/browser")({
  component: BrowserSettingsPage,
});
